import React, { useState } from 'react';
import axios from 'axios';

import './share-modal.css';

const ShareModal = (props) => {
    const [state,setState] = useState({
      showInput: null,
      more: false,
      whatsappNumber: '',
      emailAddress: '',
      error: '',
      successText:'',
      loading: false,
      modalStatus:'show'
    });
    
  const selectInput = (input, ev) => {
    setState((prevState) => {
      return {
        ...prevState,
        showInput: input,
        loading: false,
        whatsappNumber: '',
        emailAddress: '',
        error: '',
      };
    });
  }

  const updateInput = (ev) => {
    setState({
      ...state,
      [ev.target.name]: ev.target.value.replace(/ /g, ''),
      error: '',
    });
  }

  const validateEmail = (ev) => {
    ev.preventDefault();
    setState((prevState) => {
      return {
        ...prevState,
        error: '',
      };
    });
    if (!state.emailAddress) {
      setState((prevState) => {
        return {
          ...prevState,
          error: 'Email address required',
        };
      });
    } else if (!/^\S+@\S+\.\S+$/i.test(state.emailAddress) || state.emailAddress.length > 255) {
      setState((prevState) => {
        return {
          ...prevState,
          error: 'Invalid email address',
        };
      });
    } else {
      inviteMailApi();
    }
  }

  const validatewhatsappNumber = (ev) => {
    ev.preventDefault();
    setState((prevState) => {
      return {
        ...prevState,
        error: '',
      };
    });
    if (!state.whatsappNumber) {
      setState((prevState) => {
        return {
          ...prevState,
          error: 'Number is required',
        };
      });
    } else {
      callWhatsappApi();
    }
  }

  const callWhatsappApi = () => {
    //send text to whatsapp
    const text = `Come and join the app for creating and accepting exciting ${props.fitness ? 'fitness' : ''} challenges from friends.%0a%0aCheck it out here- http://about.tigbar.com/${props.fitness ? 'participate-in-online-fitness-challenges' : 'waitlist'}?referralCode=${props.referralCode}`;
    const url = `https://api.whatsapp.com/send?phone=${state.whatsappNumber}?&text=${text}`;

    setState((prevState) => {
      return {
        ...prevState,
        modalStatus: '',
      };
    });
    window.open(url, '_blank');
    // win.focus();
  }

  const inviteMailApi = () => {
    const data = {
      'emailAddress':state.emailAddress,
      'url':props.fitness ? 'participate-in-online-fitness-challenges' : 'waitlist',
      'referralCode':props.referralCode,
    }
    axios.post(`${process.env.REACT_APP_API_ENDPOINT}/sendwaitlistinvite`, data)
    .then(() => {
      setState((prevState) => {
        return {
          ...prevState,
          successText: 'Email sent succesfully!',
        };
      });
    })
    .catch(err=> {
      setState((prevState) => {
        return {
          ...prevState,
          error: err?.response?.data?.email[0] || 'Something went wrong!',
        };
      });
    })
  }

  return (
    //<!-- The invite modal -->
    <div className={`modal fade ${state.modalStatus}`} id="invite-user" role="dialog">
      <div 
        onClick={() => 
          !props.showPopup && setState((prevState) => {
          return {
            ...prevState,
            modalStatus: '',
          };
        })} 
        style={{position:'absolute',top:0,left:0,right:0,bottom:0}}>
      </div>
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content">
          {/* <!-- Modal Header --> */}
          <div className="d-flex p-2 w-100 justify-content-between">
            <h5 className="modal-title d-flex ml-auto mr-auto">Invite{props.fitness && ' Fitness Freaks'}</h5>
          </div>
          {/* <!-- Modal body --> */}
          <div className="modal-body d-flex flex-wrap">
            <div className="d-flex flex-column w-100 align-items-center">
              <div className="d-flex mb-3">
                <button
                  className="btn flex-column p-0"
                  data-action="share/whatsapp/share"
                  onClick={(ev) => selectInput(1,ev)}
                >
                  <i
                    className="fab fa-whatsapp tsy5_90"
                    style={{ color: '#50CB33' }}
                    color="#50CB33"
                  ></i>
                  <p className='small-text'>WhatsApp</p>
                </button>
                <button className="flex-column btn p-0 mx-4" onClick={(ev) => selectInput(2,ev)}>
                  <i
                    className="fas fa-envelope invite-png tsy5_90 text-warning"
                    style={{ color: '' }}
                  />
                  <p className='small-text'>Email</p>
                </button>
                <div className="fb-share-button" data-href={props.fitness ? `https://about.tigbar.com/participate-in-online-fitness-challenges?referralCode=${props.referralCode}` : `https://about.tigbar.com/waitlist?referralCode=${props.referralCode}`} data-layout="" data-size="">
                  <a target="_blank" rel='noreferrer' href={props.fitness ? `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fabout.tigbar.com%2Fparticipate-in-online-fitness-challenges%3FreferralCode%3D${props.referralCode}&amp;src=sdkpreparse` : `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fabout.tigbar.com%2Fwaitlist%3FreferralCode%3D${props.referralCode}&amp;src=sdkpreparse`} className="fb-xfbml-parse-ignore"><button className="flex-column btn p-0" onClick={(ev) => selectInput(2,ev)}>
                    <i
                      className="fab fa-facebook fb-icon invite-png tsy5_90"
                      style={{ color: '#0766FF' }}
                    />
                    <p className='small-text'>Facebook</p>
                  </button>
                  </a>
                </div>
              </div>

              {/* Show WhatsappNumber input */}
              {state.showInput === 1 ? (
                <div className="d-flex mt-3 flex-column">
                  <form method="POST" className="d-flex align-items-center">
                    <label
                      htmlFor="whatsapp-invite"
                      className="d-flex mb-0 mr-3 w-75 relative-div whatsapp-invite"
                    >
                      <input
                        id="whatsapp-invite"
                        className="form-control border pl-3"
                        type="number"
                        placeholder="+1298765432"
                        autoFocus={true}
                        name="whatsappNumber"
                        onChange={updateInput}
                        value={state.whatsappNumber}
                      />
                    </label>
                    <button
                      className="btn send-invite btn-primary"
                      onClick={validatewhatsappNumber}
                    >
                      {state.loading ? (
                        <div className="spinner-border spinner-border-sm"></div>
                      ) : (
                        'Invite'
                      )}
                    </button>
                  </form>
                  {state.error && (
                    <span className="error text-danger fonts-md mt-2">{state.error}</span>
                  )}
                  {state.successText && (
                    <span className="text-success fonts-md mt-2">{state.successText}</span>
                  )}
                </div>
              ) : null}
              {/* Show EmailAddress input */}
              {state.showInput === 2 ? (
                <div className="d-flex mt-3 flex-column">
                  <form method="POST" className="d-flex align-items-center">
                    <label htmlFor="gmail-invite" className="d-flex mb-0 mr-3 w-75">
                      <input
                        id="gmail-invite"
                        className="form-control border pl-3"
                        type="text"
                        autoFocus={true}
                        placeholder="Email Address"
                        name="emailAddress"
                        onChange={updateInput}
                        value={state.emailAddress}
                      />
                    </label>
                    <button className="btn send-invite btn-primary" onClick={validateEmail}>
                      {state.loading ? (
                        <div className="spinner-border spinner-border-sm"></div>
                      ) : (
                        'Invite'
                      )}
                    </button>
                  </form>
                  {state.error && (
                    <span className="error text-danger fonts-md mt-2">{state.error}</span>
                  )}
                  {state.successText && (
                    <span className="text-success fonts-md mt-2">{state.successText}</span>
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
    //<!-- end modal -->
  );
}

export default ShareModal;
